module.exports = __webpack_public_path__ + "../resources/img/ic_re_smart_plug_default.609a28f9.svg";